import { addMinutes, differenceInMinutes } from "date-fns";
import { roundTimeByStep } from "./time";
import { uid } from "./helpers";
export function saveForm(editorShape, dispatch, store) {
    const { formValues, mode } = store.get();
    const event = { id: formValues.id };
    editorShape.forEach(field => {
        if (field.type === "date" && field.time) {
            const date = formValues[field.key];
            const time = formValues[`${field.key}_time`];
            date.setHours(time.getHours(), time.getMinutes());
            formValues[field.key] = date;
        }
        event[field.key] = formValues[field.key];
    });
    dispatch("action", {
        action: `${mode}-event`,
        data: {
            event,
            id: formValues.id,
        },
    });
    store.set({ mode: "update", isChanged: false });
}
export function setDefaults(obj, editorShape, mode, defaultEventDuration, store, currentDate, setter) {
    const copy = { ...obj };
    const today = new Date();
    currentDate.setHours(today.getHours(), today.getMinutes());
    editorShape.forEach(f => {
        if (typeof copy[f.key] === "undefined") {
            let val;
            switch (f.type) {
                case "files":
                    val = [];
                    break;
                case "date":
                    val = roundTimeByStep(f.key !== "end_date"
                        ? currentDate
                        : addMinutes(copy["start_date"], defaultEventDuration), defaultEventDuration);
                    break;
                case "text":
                    val = f.label || "";
                    break;
                case "checkbox":
                    val = false;
                    break;
                case "colorSchema":
                    val = {};
                    break;
                default:
                    val = "";
            }
            copy[f.key] = val;
        }
        if (f.type === "multiselect" && copy[f.key].length) {
            copy[f.key] = copy[f.key].map((i) => typeof i === "string" ? i : i.id);
        }
        if (f.type === "date" && f.time) {
            copy[`${f.key}_time`] = new Date(copy[f.key]);
        }
        if (f.type === "files" && !(copy[f.key] instanceof Array)) {
            copy[f.key] = [copy[f.key]];
        }
    });
    if (mode === "add") {
        copy.id = copy.id ?? uid();
        store.set({ isChanged: false, mode, formValues: copy });
        setter(copy);
    }
    else {
        store.set({
            isChanged: false,
            mode,
            formValues: copy,
            prevValues: { ...copy },
        });
    }
    return copy;
}
export class EditorStore {
    constructor(s) {
        this._observers = [];
        this._state = {
            isChanged: false,
            formValues: {},
            prevValues: {},
            mode: "update",
            showEditor: false,
            defaultEventDuration: 5,
            disabledTimepicker: false,
        };
        this._state = {
            ...this._state,
            ...s,
        };
    }
    subscribe(observer) {
        this._observers.push(observer);
        this.set(this._state);
        return () => this.unsubscribe(observer);
    }
    unsubscribe(observer) {
        this._observers = this._observers.filter(ob => ob !== observer);
    }
    set(state) {
        this._state = { ...this._state, ...state };
        this._observers.forEach(ob => {
            ob(this._state);
        });
    }
    get() {
        return this._state;
    }
}
export function validateForm(values, defaultEventDuration, formState, store) {
    let validation = {};
    if (values.start_date && values.end_date) {
        let { end_date, end_date_time } = values;
        const { start_date_time, start_date } = values;
        const { start_date_time: prev_start_date_time, end_date: prev_end_date, end_date_time: prev_end_date_time, start_date: prev_start_date, } = formState.get().prevValues;
        if (start_date_time && start_date_time) {
            start_date.setHours(start_date_time.getHours(), start_date_time.getMinutes());
        }
        if (prev_start_date && prev_end_date_time) {
            prev_start_date.setHours(prev_start_date_time.getHours(), prev_start_date_time.getMinutes());
        }
        if (prev_end_date && prev_end_date_time) {
            prev_end_date.setHours(prev_end_date_time.getHours(), prev_end_date_time.getMinutes());
        }
        if (end_date_time && end_date_time) {
            end_date.setHours(end_date_time.getHours(), end_date_time.getMinutes());
        }
        if (prev_start_date &&
            prev_start_date.valueOf() !== start_date.valueOf()) {
            const diff = differenceInMinutes(prev_end_date, prev_start_date);
            end_date = addMinutes(start_date, diff);
            end_date_time = new Date(end_date);
        }
        if (start_date > end_date) {
            end_date = addMinutes(start_date, defaultEventDuration);
            end_date_time = new Date(end_date);
        }
        validation = {
            end_date,
            end_date_time,
        };
    }
    const validValues = {
        ...values,
        ...validation,
    };
    formState.set({
        formValues: validValues,
        prevValues: { ...validValues },
        isChanged: true,
        disabledTimepicker: values.allDay,
    });
    store.reset(validValues);
}
//# sourceMappingURL=editor.js.map